<template>
    <div class="cmpt">
        <div class="container">
            <!-- title -->
            <home-title :title="'关于我们'" :isHot="false" />
            <p class="top-text">
                <b>DataFountain</b>是北京清研兰亭科技有限公司旗下品牌，是<b>国内领先的数据竞赛服务平台和数据智能协同创新平台</b>，旨在围绕<b>协作</b>、<b>数据</b>、<b>知识</b>、<b>技能</b>形成大数据爱好者的专业成长链路，为<b>数据科学家及产业赋能</b>。
            </p>
            <!-- <p class="bottom-text">
                为了<b>帮助大学生快速学习和了解人工智能基础知识</b>，学会自主学习，自觉扎牢知识基础，不断增强创新能力，经研究决定，<b
                    >赢取百万大奖，角逐全球排行榜！</b
                >
            </p> -->
            <a class="more" href="/about/us">咨询合作办赛</a>
        </div>
    </div>
</template>

<script>
import HomeTitle from './HomeTitle.vue';
export default {
    data() {
        return {};
    },

    components: { HomeTitle },

    computed: {
        user() {
            return this.$store.getters.userInfo;
        },
    },

    created() {
        // this.$axios('getHomeBannerList').then(res => {
        //     this.bannerList = res.data;
        // });
    },
};
</script>

<style lang="scss" scoped>
.cmpt {
    margin-top: 22px;
    padding: 0 14px;

    .container {
        padding-top: 12px;
        width: 724px;
        height: 720px;
        background: #ffffff;
        border-radius: 28px;
        background: url('../../assets/home/aboutus@2x.png') no-repeat 0 0;
        background-size: 722px 720px;
        p {
            font-size: 24px;
            font-family: PingFangSC-Light, PingFang SC;
            font-weight: 300;
            color: #232526;
            line-height: 46px;
            margin: 32px;
            text-indent: 2em;
            line-height: 60px;
        }
        .top-text {
            margin-top: 60px;
            line-height: 100px;
        }
        a.more {
            display: inline-block;
            text-align: center;
            line-height: 76px;
            width: 330px;
            height: 76px;
            background: linear-gradient(270deg, #3A6DE6 0%, #5484F7 100%);
            box-shadow: 0px 8px 12px 0px rgba(58,109,230,0.25), 0px 0px 0px 0px rgba(255,255,255,0.5);
            border-radius: 38px;
            font-size: 28px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #fefffe;
            transform: translateX(-50%);
            margin-left: 50%;
        }
        // .bottom-text{
        //     margin-top: 50px;
        // }
    }
}
</style>
